import { useState, useEffect } from "react";






type param = { key: string, name: string, fn?: (value: any) => any, text?: string }

export function useValidate( params: param[] ) {
    const [errors, setErrors] = useState<Array<string> | null>(null);

    const validate = (data: Record<string, any>): Promise<void> => {
        return new Promise((resolve, reject) => {
            let newErrors: string[] = [];

            Object.keys(data).forEach(key => {
                const param = params.find(i => i.key === key);
                if (param) {
                    if (param.fn) {
                        if (!param.fn(data[key])) {
                            newErrors.push(param.text?.trim() || `Заполните поле ${param.name}`);
                        }
                    } else if (typeof data[key] === "string" && !data[key].trim()) {
                        newErrors.push(param.text?.trim() || `Заполните поле ${param.name}`);
                    }
                }
            });

            if (newErrors.length > 0) {
                setErrors(newErrors);
                reject(newErrors);
            } else {
                setErrors(null);
                resolve();
            }
        });
    };


    return { validate, errors }
}

